module.exports = __webpack_public_path__ + "img/icon-eye.a1391ea9.svg";